import {SurveyPayload} from "infrastructure/services/surveyResponse.service";

type GuideKey = "II" | "III";

const expectedQuestionsByGuide: Record<GuideKey, string[]> = {
    II: Array.from({length: 46}, (_, i) => `GII_${i + 1}`),
    III: Array.from({length: 72}, (_, i) => `GIII_${i + 1}`),
};

export function buildSurveyPayload(guide: GuideKey): SurveyPayload | null {
    const token = localStorage.getItem("user-token");
    const campaignId = localStorage.getItem("campaign");

    const descartar = (motivo: string): null => {
        console.error(`[buildSurveyPayload] no se pudo construir: ${motivo}`);
        return null;
    };

    if (!token) return descartar("falta 'user-token' en localStorage");
    if (!campaignId) return descartar("falta 'campaign' en localStorage");

    const tokenMapRaw = localStorage.getItem("NOM035_tokenMap");
    const tokenMap = tokenMapRaw ? JSON.parse(tokenMapRaw) : {};
    const current = tokenMap[token];

    if (!current) return descartar(`NOM035_tokenMap no tiene entrada para el token ${token}`);
    if (!current.answers) return descartar("la entrada del token no tiene 'answers'");
    if (!current.scores) return descartar("la entrada del token no tiene 'scores'");

    const guiaIScores = current.scores.GUIA_I;
    const guideKey = `GUIA_${guide}`;
    const guideAnswers = current.answers[guideKey];

    if (!guideAnswers || typeof guideAnswers !== "object") {
        return descartar(`no hay respuestas guardadas para ${guideKey}`);
    }

    const demographics = current.demographics;


    const fullAnswers: Record<string, number | boolean> = {
        ...guiaIScores,
        ...guideAnswers,
    };

    // Asegura que no falte ninguna pregunta
    for (const questionId of expectedQuestionsByGuide[guide]) {
        if (!(questionId in fullAnswers)) {
            fullAnswers[questionId] = 0;
        }
    }

    // Normaliza los booleanos al final
    const booleanPrefix = `GUIA_${guide}_`;

    const isBossKey = `${booleanPrefix}isBoss`;
    const serviceKey = `${booleanPrefix}serviceToClients`;

    if (isBossKey in guideAnswers) {
        fullAnswers["isBoss"] = guideAnswers[isBossKey];
    }
    if (serviceKey in guideAnswers) {
        fullAnswers["serviceToClients"] = guideAnswers[serviceKey];
    }

    // Define orden esperado
    const orderBeforeSend = [
        ...Array.from({length: 6}, (_, i) => `GI_I_${i + 1}`),
        ...Array.from({length: 2}, (_, i) => `GI_II_${i + 1}`),
        ...Array.from({length: 7}, (_, i) => `GI_III_${i + 1}`),
        ...Array.from({length: 5}, (_, i) => `GI_IV_${i + 1}`),
        ...expectedQuestionsByGuide[guide],
        "serviceToClients",
        "isBoss",
    ];

    // Construye responses en orden
    const orderedResponses: Record<string, number | boolean> = {};
    for (const key of orderBeforeSend) {
        if (key in fullAnswers) {
            orderedResponses[key] = fullAnswers[key];
        }
    }

    return {
        token,
        campaign: campaignId,
        guide_id: `guia-${guide.toLowerCase()}`,
        demographics,
        responses: orderedResponses,
    };
}
